import React from 'react'
import useSaga from 'hooks/useSaga'
import { takeEvery } from 'redux-saga/effects'
import { PUSH, PUSH_CARD } from 'index'
import { History } from 'history'


function * saga (history) {
  yield takeEvery(PUSH, (action: any) => { history.push(...action.payload) })

  yield takeEvery(PUSH_CARD, (action: any) => {
    history.push(
      `/card/${action.payload.cardId}`,
      {
        fromLocation: history.location.state?.fromLocation || history.location,
      }
    )
  })
}

type Props = {
  history: History
}

const ReduxRouterHelper: React.FC<Props> = ({ history }) => {
  useSaga(saga, history)

  return null
}

export default ReduxRouterHelper
